import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 163CB77E-4663-4F8E-B73E-20FCC5C5BED3
 * name view-column
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-column.svg
 * tags
 * - View 
 */
export const ViewColumnIcon = createSvgIcon(<><path d="M16,5V18H21V5M4,18H9V5H4M10,18H15V5H10V18Z" /></>, 'ViewColumnIcon');
export default ViewColumnIcon